/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-24 17:21:31
 * @LastEditors: K
 * @LastEditTime: 2022-09-21 13:45:16
 */
import { TableColumnType } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  street: string;
  building: string;
  number: number;
  companyAddress: string;
  companyName: string;
  gender: string;
}

export const Columns = (): ColumnsType<any> => {


  return [
    {
      title: '省份',
      dataIndex: 'province',
      key: 'province',
      width: 100,
      fixed: 'left',
      align: 'center',
    },
    {
      title: '总计',
      dataIndex: 'hospitalAggregateNum',
      key: 'hospitalAggregateNum',
      width: 100,
      fixed: 'left',
      align: 'center',
      render: (_, t) => t.hospitalAggregateNum ? t.hospitalAggregateNum : '-'
    },
    {
      title: '单位类别',
      children: [
        // {
        //   title: 'Age',
        //   dataIndex: 'age',
        //   key: 'age',
        //   width: 150,
        //   sorter: (a, b) => a.age - b.age,
        // },
        {
          title: '医院',
          children: [
            {
              title: '总计',
              dataIndex: 'hospitalNum',
              key: 'hospitalNum',
              align: 'center',
              render: (_, t) => t.hospitalNum ? t.hospitalNum : '-'
            },
            {
              title: '公立医院',
              dataIndex: 'publicHospitalNum',
              key: 'publicHospitalNum',
              align: 'center',
              render: (_, t) => t.publicHospitalNum ? t.publicHospitalNum : '-'
            },
            {
              title: '民营医院',
              dataIndex: 'privateHospitalNum',
              key: 'privateHospitalNum',
              align: 'center',
              render: (_, t) => t.privateHospitalNum ? t.privateHospitalNum : '-'
            },
            {
              title: '综合医院',
              dataIndex: 'synthesisHospitalNum',
              key: 'synthesisHospitalNum',
              align: 'center',
              render: (_, t) => t.synthesisHospitalNum ? t.synthesisHospitalNum : '-'
            },
            {
              title: '中医医院',
              dataIndex: 'tcmHospitalNum',
              key: 'tcmHospitalNum',
              align: 'center',
              render: (_, t) => t.tcmHospitalNum ? t.tcmHospitalNum : '-'
            },
            {
              title: '中西医结合医院',
              dataIndex: 'traditionalChinese',
              key: 'traditionalChinese',
              align: 'center',
              render: (_, t) => t.traditionalChinese ? t.traditionalChinese : '-'
            },
            {
              title: '专科医院',
              dataIndex: 'juniorCollege',
              key: 'juniorCollege',
              align: 'center',
              render: (_, t) => t.juniorCollege ? t.juniorCollege : '-'
            },

          ],
        },
        {
          title: '基层医疗卫生机构',
          children: [
            {
              title: '总计',
              dataIndex: 'jcAggregateNum',
              key: 'jcAggregateNum',
              align: 'center',
              render: (_, t) => t.jcAggregateNum ? t.jcAggregateNum : '-'
            },
            {
              title: '社区卫生服务中心(站)',
              dataIndex: 'communityHealthNum',
              key: 'communityHealthNum',
              align: 'center',
              render: (_, t) => t.communityHealthNum ? t.communityHealthNum : '-'
            },
            {
              title: '乡镇卫生院',
              dataIndex: 'whistleStopNum',
              key: 'whistleStopNum',
              align: 'center',
              render: (_, t) => t.whistleStopNum ? t.whistleStopNum : '-'
            },
            {
              title: '诊所(医务室)',
              dataIndex: 'clinicNum',
              key: 'clinicNum',
              align: 'center',
              render: (_, t) => t.clinicNum ? t.clinicNum : '-'
            },
            {
              title: '村卫生室',
              dataIndex: 'villageNum',
              key: 'villageNum',
              align: 'center',
              render: (_, t) => t.villageNum ? t.villageNum : '-'
            },
          ],
        },
        {
          title: '专业公共卫生机构',
          dataIndex: 'professionalPublicNum',
          key: 'professionalPublicNum',
          align: 'center',
          render: (_, t) => t.professionalPublicNum ? t.professionalPublicNum : '-'
        },
        {
          title: '其他机构',
          dataIndex: 'otherTenantNum',
          key: 'otherTenantNum',
          align: 'center',
          render: (_, t) => t.otherTenantNum ? t.otherTenantNum : '-'
        },
      ],
    },
    {
      title: '专科',
      children: [
        {
          title: '中医机构',
          children: [
            {
              title: '总计',
              dataIndex: 'zkAggregateNum',
              key: 'zkAggregateNum',
              align: 'center',
              render: (_, t) => t.zkAggregateNum ? t.zkAggregateNum : '-'
            },
            {
              title: '中医类医院',
              dataIndex: 'zkTcmHospitalNum',
              key: 'zkTcmHospitalNum',
              align: 'center',
              render: (_, t) => t.zkTcmHospitalNum ? t.zkTcmHospitalNum : '-'
            },
            {
              title: '中医类门诊部(诊所)',
              dataIndex: 'zkTcmOutpatientNum',
              key: 'zkTcmOutpatientNum',
              align: 'center',
              render: (_, t) => t.zkTcmOutpatientNum ? t.zkTcmOutpatientNum : '-'
            },
            {
              title: '其他机构中医类临床科室',
              dataIndex: 'zkOtherTenantTcmNum',
              key: 'zkOtherTenantTcmNum',
              align: 'center',
              render: (_, t) => t.zkOtherTenantTcmNum ? t.zkOtherTenantTcmNum : '-'
            },
          ],
        },
        {
          title: '口腔类机构',
          dataIndex: 'oralCavityNum',
          key: 'oralCavityNum',
          align: 'center',
          render: (_, t) => t.oralCavityNum ? t.oralCavityNum : '-'
        },

      ],
    },
    // {
    //   title: 'Company',
    //   children: [
    //     {
    //       title: 'Company Address',
    //       dataIndex: 'companyAddress',
    //       key: 'companyAddress',
    //       width: 200,
    //     },
    //     {
    //       title: 'Company Name',
    //       dataIndex: 'companyName',
    //       key: 'companyName',
    //     },
    //   ],
    // },
    // {
    //   title: 'Gender',
    //   dataIndex: 'gender',
    //   key: 'gender',
    //   width: 80,
    //   fixed: 'right',
    // },
  ];
}

